"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blankSurvey_exports = {};
__export(blankSurvey_exports, {
  blankSurvey: () => blankSurvey,
  defaultBlankSurveyOpts: () => defaultBlankSurveyOpts
});
module.exports = __toCommonJS(blankSurvey_exports);
var import_topo_survey = require("@cartographerio/topo-survey");
var import_types = require("@cartographerio/types");
var import_lodash = require("lodash");
var import_initialise = require("./initialise.js");
const defaultBlankSurveyOpts = import_initialise.defaultInitialiseOpts;
function blankSurvey(form, schema, moduleId, projectId, teamId, opts = defaultBlankSurveyOpts) {
  const now = (0, import_types.nowTimestamp)();
  const {
    id = (0, import_types.randomSurveyId)(),
    surveyor = void 0,
    created = now,
    updated = now,
    schemaVersion = import_types.initialSchemaVersion
  } = opts;
  return (0, import_initialise.initialiseForm)(form, schema, [], (0, import_topo_survey.schemaBlankValue)(schema), opts).map(
    (doc) => (0, import_lodash.merge)(doc, {
      id,
      moduleId,
      projectId,
      teamId,
      surveyor,
      created,
      updated,
      schemaVersion
    })
  ).mapError((msg) => (0, import_types.internalError)(`Error creating blank ${moduleId} data: ${JSON.stringify(msg)}`)).guardWith(import_types.isSurvey, (s) => (0, import_types.internalError)("blankSurvey returned non-survey | " + JSON.stringify(s)));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  blankSurvey,
  defaultBlankSurveyOpts
});
//# sourceMappingURL=blankSurvey.js.map
